
import { defineComponent } from 'vue'

import { IconArrowLeft } from '@/components/Icons'

export default defineComponent({
  name: 'Navbar',
  components: { IconArrowLeft },
  props: {
    linkName: { type: String, required: true },
    routeName: { type: String, required: true },
  },
})
